import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PEE_ARIA, PEE_CAPABILITIES, PEE_FULL_NAME } from "@/lib/looseend/pee";

/** Informational modal explaining the engine inside the L∞seEnd™ system. */
export function AboutPeeModal({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90dvh] overflow-y-auto rounded-2xl sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>
            <span aria-label={PEE_ARIA}>PEE™</span>
          </DialogTitle>
          <DialogDescription>{PEE_FULL_NAME}</DialogDescription>
        </DialogHeader>

        <div className="space-y-3 text-sm leading-relaxed text-muted-foreground">
          <p>PEE™ is the intelligence inside the L∞seEnd™ Personal Execution System.</p>
          <div>
            <p className="text-foreground">It helps L∞seEnd™:</p>
            <ul className="mt-1.5 space-y-1">
              {PEE_CAPABILITIES.map((item) => (
                <li key={item} className="flex gap-2">
                  <span aria-hidden="true" className="text-primary">
                    ·
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <p>
            L∞seEnd™ is the system. PEE™ is the engine. Loops are what the system helps you resolve.
          </p>
        </div>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>Got it</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
